import { useEffect } from "react";
import { useAuth } from "@/lib/auth";
import { initPush } from "@/lib/push";

// Mounts once; registers web-push after the user is authenticated.
export default function PushInit() {
  const { user } = useAuth();
  useEffect(() => {
    if (user) initPush(user);
  }, [user]);
  return null;
}
